export default {
  netlify: {
    identity: process.env.REACT_APP_NETLIFY_IDENTITY,
  },
  host: {
    uri: process.env.REACT_APP_HOST,
  },
  server: {
    uri: process.env.REACT_APP_SERVER_URI,
  },
  stripe: {
    stripePublishingKey: process.env.REACT_APP_STRIPE_PUBLISHING_KEY,
  },
};
